/**
 * 公众号
 * */
import React, {Component} from 'react';
import {Card, Button, Input, List, Modal, Tabs, Icon, Empty, Popconfirm, message} from 'antd';
import StuffCard from "../../components/weChatPulish/stuffCard";
import {connect} from 'react-redux'
import {Scrollbars} from 'react-custom-scrollbars';
import {HEADER_HEIGHT} from "../../../constants";
import {base64Encode, uuid} from "../../../utils";
import {getExaminedList, getMaterialList, getTodoListList, installedPlugin} from "../../../actions/weiChat";
import EditMaterial from "../../components/weChatPulish/editMaterial";
import './weChatPublish.scss'
import BaseComponent from "../../../base/BaseComponent";
import PlugInData from "../components/plug-in_data";
import Masonry from 'react-masonry-css'
import InfoAuth from "../../mediaManage/pms/InfoAuth";
import weChat from "../../mediaManage/images/wechat.png";
import {verifyBaiJiaHao, verifyWebsite, verifyWechat} from "../../mediaManage/actions/mediaAdminister";

const {Search} = Input;
const {TabPane} = Tabs;
const tabList = [
    {
        key: 'all',
        tab: '所有图文',
    },
    {
        key: 'needHandle',
        tab: '待我处理',
    },
    {
        key: 'draft',
        tab: '草稿箱'
    },
    {
        key: 'audit',
        tab: '审核中'
    },
    /* {
         key: 'adopt',
         tab: '已定稿',
     },*/
    {
        key: 'published',
        tab: '已发布',
    },
    {
        key: 'abandoned',
        tab: '已弃用',
    },

];

class WeChatPublish extends BaseComponent {

    // 记录每个tab页当前页码
    defaultParams = {
        mediaId: this.props && this.props.match && this.props.match.params && this.props.match.params.currentMedia ? this.props.match.params.currentMedia : 0,
        allStart: 1, //全部
        needHandleStart: 1, //待办
        publishedStart: 1, //发布
        abandonedStart: 1, //弃用
        draftStart: 1, //草稿
        auditStart: 1, //审核中
        approvedStart: 1, //通过
        queryStr: "",
    };

    params = Object.assign({}, this.defaultParams);

    default = {
        start: 1,
        size: 16,
    };

    state = {
        loading: true,
        key: 'all',
        allData: [], // 全部
        needHandleData: [], // 待办
        publishedData: [], // 发布
        abandonedData: [], // 弃用
        draftData: [], // 草稿
        auditData: [], // 审核中
        adoptData: [], // 定稿
        approvedData: [], // 通过
        editModalVisible: false,
        editModalTitle: "",
        editModalMaterialId: 0,
        topRedNum: 0,
        disable: true,
        weChatVisible:false,
        description:'',
        authResult:0,
    };

    componentWillMount() {
        let that = this;
        // 监听微信后台页面发送的消息
        this.createPostMessage( (e) => {
            if(typeof e.data=='string'&&e.origin=='https://mp.weixin.qq.com'){
                let source = e.source;
                let data = e['data'] ? JSON.parse(e['data']) : null;
                if(data) {
                    // 秀米请求调用接口并回传
                    if(data.type === 'requestAndCall') {
                        that.requestFromPostMessage(data,source)
                    }
                    // 微信请求用户信息
                    if(data.type === 'weixin') {
                        that.callWeinXinData()
                    }
                }
            }
        }, "WeChatPublish")
    }

    callWeinXinData = () => {
        this.plugInData.getData(null, (res)=>{
            this.callResByWeinXin({...res,type:'weixin',mediaId:this.defaultParams.mediaId});
        });
    };

    // 远端请求接口参数
    requestFromPostMessage = (message,source) => {
        let {requestReq, opener} = message;
        if(requestReq && requestReq.url) {
            let url = requestReq.url;
            let method = requestReq.method || 'get';
            let body = requestReq.body || {};
            let contentType = requestReq.contentType || "";
            body = this.encryptContent(body);
            this.request({
                url,method,body,contentType,
                callBack: (res) => {
                    let request = {...message,
                        requestRes: res
                    };
                    if(opener) {
                        if(opener=="weixin") {
                            this.callResByWeinXin({...request,mediaId:this.defaultParams.mediaId},source)
                        } else if(opener=="135") {

                        } else {

                        }
                    }
                }
            })
        }
    };

    encryptContent = (data) => {
        if(data && data.stuffList && data.stuffList.length) {
            data.stuffList = data.stuffList.map(item=>({
                ...item,
                content: base64Encode(item.content),
            }));
        }
        return data
    };

    // 给微信回传参数
    callResByWeinXin = (request,source) => {
        if(source &&  (typeof source.postMessage === 'function')) {
            source.postMessage(JSON.stringify(request), "*");
            return
        }
        const { weixinOpener } = this;
        if(weixinOpener && (typeof weixinOpener.postMessage === 'function')) {
            weixinOpener.postMessage(JSON.stringify(request), "*");
        }
    };

    componentDidMount() {
        this.initData(this.state.key, true);
        if(this.defaultParams.mediaId){
            this.getDisable();
        }
        if(this.urlParams) {
            if(this.urlParams.stuffList && this.urlParams.stuffList.length) {
                this.editMaterial(-1)
            }
        }
        this.initData("needHandle")
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.match&&nextProps.match.params&& nextProps!==this.props){
            this.defaultParams.mediaId = nextProps.match.params.currentMedia;
            if (this.defaultParams.mediaId&&this.defaultParams.mediaId!=='') {
                this.getDisable();
            }
            this.params = Object.assign({}, this.defaultParams);
            console.log(this.defaultParams)
            this.initData(this.state.key, true);
        }
    }

    componentWillUnmount() {
        // 销毁postMessage监听
        this.destroyPostMessage("WeChatPublish")
    }

    render() {
        let {editModalVisible, editModalTitle, editModalMaterialId} = this.state;
        return (
            <div className="we-xin-publish" style={{background: '#ffffff', height: 'calc(100vh - 100px)',margin: 15,borderRadius:'5px'}}>
                {/*tabBar*/}
                {this.renderTitle()}
                {/*search and add*/}
                {this.renderTop()}
                {/*weChat list*/}
                {this.renderContent()}
                {/*add or edit Model*/}
                <MaterialModel
                    callback={this.callback}
                    mediaName={this.state.mediaName}
                    visible={editModalVisible}
                    title={editModalTitle}
                    mediaId={this.params.mediaId}
                    materialId={editModalMaterialId}
                    refeshList={() => {
                        this.reloadMaterialList()
                    }}
                    updateVisible={this.updateEditModalVisible.bind(this)}
                />
                {/*get current data*/}
                <PlugInData ref={ref=>this.plugInData=ref}/>
                <InfoAuth
                    webInfoVisible={this.state.weChatVisible}
                    mediaTypeName={'公众号'}
                    mediaTypeCode={"material"}
                    logoUrl= {weChat}
                    name={this.state.description}
                    onRef={(c) => this.informationAuth = c}
                    infoAuthCancel={() => {
                        this.setState({
                            weChatVisible: false
                        })
                    }}
                    infoAuth={(params) => {
                        this.infoAuth(params)
                    }}
                />
            </div>
        );
    }


    // 获取数据
    initData = (currentTab, clear) => {
        if (currentTab === 'all') { // 所有
            let params = {
                // tabType: currentTab,
                page: (() => {
                    if (clear) {
                        this.params.allStart = this.defaultParams.allStart;
                    }
                    return this.params.allStart
                })(),
                size: this.default.size,
                mediaId: this.params.mediaId,
                keywords: this.params.queryStr
            };
            this.request({
                url: '/cm-sites-pms/material/pageList',
                body: params,
                callBack: (res) => {
                    let data = [];
                    if(res&&res.data) {
                        data = res.data;
                    }
                    this.setState(prevState => {
                        if (clear || params.start === 1) {
                            prevState.allData = [];
                        }
                        this.reloadAllDataCache(data);
                        prevState.allData.push(...data);
                        prevState.loading = false;
                        return prevState;
                    });
                }
            });
            // getMaterialList(params,(res)=>{
            //     this.setState(prevState=>{
            //         if(clear||params.start===1){
            //             prevState.allData = [];
            //         }
            //         this.reloadAllDataCache(res.data);
            //         prevState.allData.push(...res.data);
            //         prevState.loading = false;
            //         return prevState;
            //     });
            //     window.loading.hide();
            // })
        } else if (currentTab === 'needHandle') { // 待办
            let params = {
                activitiCategoryKeys: ["material"],
                fieldQuery: {
                    queryRelationTypeEnum:"AND",
                    queryList: [
                        {
                            fieldName: "processData.data.mediaId",
                            queryTypeEnum: "IS",
                            valueTypeEnum: "STRING",
                            value: this.params.mediaId,
                            queryRelationTypeEnum: "AND",
                            queryList: null
                        },
                    ]
                },
                // mediaId: this.params.mediaId,
                showData: true,
                operatorUser: (window.currentUser && window.currentUser.id) ? window.currentUser.id : "",
                page: {
                    start: (() => {
                        if (clear) {
                            this.params.needHandleStart = this.defaultParams.needHandleStart;
                        }
                        console.log(this.params.needHandleStart)
                        return this.params.needHandleStart
                    })(),
                    size:this.default.size,
                },
                title: this.params.queryStr,
                // "query": {
                //     "equalsMap": {
                //         "pojoName": "material", "data.mediaId": this.params.mediaId
                //     }
                // },
            };
            this.request({
                url: '/cm-sites-sys/process/getTodoList',
                body: params,
                method: 'post',
                contentType: 'json',
                callBack: (res) => {
                    this.setState(prevState => {
                        prevState.needHandleData = [];
                        let data = res || {};
                        let list = data.data || [];
                        let count = data.count || 0;
                        list = list.map(item=>({
                            ...item.data
                        }));
                        this.reloadAllDataCache(list);
                        prevState.topRedNum = count;
                        prevState.needHandleData.push(...list);
                        prevState.loading = false;
                        return prevState;
                    });
                }
            });
            // if (this.params.queryStr) {
            //     params.query["likeMap"] = {"data.stuffList.title": this.params.queryStr};
            // }
            // getTodoListList(params, (res) => {
            //     this.setState(prevState => {
            //         //  if(clear){
            //         prevState.needHandleData = [];
            //         //  }
            //         this.reloadAllDataCache(res);
            //         prevState.topRedNum = res.count;
            //         prevState.needHandleData.push(...res);
            //         prevState.loading = false;
            //         return prevState;
            //     });
            //     window.loading.hide();
            // });
        } else if (currentTab === 'published') { // 已发布
            let params = {
                // tabType: currentTab,
                page: (() => {
                    if (clear) {
                        this.params.publishedStart = this.defaultParams.publishedStart;
                    }
                    return this.params.publishedStart
                })(),
                size: this.default.size,
                mediaId: this.params.mediaId,
                keywords: this.params.queryStr
            };
            this.request({
                url: '/cm-sites-pms/material/publishList',
                body: params,
                callBack: (res) => {
                    let data = [];
                    if(res.data) {
                        data = res.data;
                    }
                    this.setState(prevState => {
                        if (clear || params.start === 1) {
                            prevState.publishedData = [];
                        }
                        this.reloadAllDataCache(data);
                        prevState.publishedData.push(...data);
                        prevState.loading = false;
                        return prevState;
                    });
                }
            });
            // getMaterialList(params, (res) => {
            //     this.setState(prevState => {
            //         if (clear || params.start === 1) {
            //             prevState.publishedData = [];
            //         }
            //         this.reloadAllDataCache(res.data);
            //         prevState.publishedData.push(...res.data);
            //         prevState.loading = false;
            //         return prevState;
            //     });
            //     window.loading.hide();
            // })
        } else if (currentTab === 'abandoned') { // 已弃用
            let params = {
                tabType: currentTab,
                page: (() => {
                    if (clear) {
                        this.params.abandonedStart = this.defaultParams.abandonedStart;
                    }
                    return this.params.abandonedStart
                })(),
                size: this.default.size,
                mediaId: this.params.mediaId,
                keywords: this.params.queryStr
            };
            this.request({
                url: '/cm-sites-pms/material/abandonList',
                body: params,
                callBack: (res) => {
                    let data = [];
                    if(res.data) {
                        data = res.data;
                    }
                    this.setState(prevState => {
                        if (clear || params.start === 1) {
                            prevState.abandonedData = [];
                        }
                        this.reloadAllDataCache(data);
                        prevState.abandonedData.push(...data);
                        prevState.loading = false;
                        return prevState;
                    });
                }
            });
            // getMaterialList(params, (res) => {
            //     this.setState(prevState => {
            //         if (clear || params.start === 1) {
            //             prevState.abandonedData = [];
            //         }
            //         this.reloadAllDataCache(res.data);
            //         prevState.abandonedData.push(...res.data);
            //         prevState.loading = false;
            //         return prevState;
            //     });
            //     window.loading.hide();
            // })
        } else if (currentTab === 'draft') { // 草稿箱
            let params = {
                tabType: currentTab,
                page: (() => {
                    if (clear) {
                        this.params.draftStart = this.defaultParams.draftStart;
                    }
                    return this.params.draftStart
                })(),
                size: this.default.size,
                mediaId: this.params.mediaId,
                keywords: this.params.queryStr
            };
            this.request({
                url: '/cm-sites-pms/material/draftList',
                body: params,
                callBack: (res) => {
                    let data = [];
                    if(res.data) {
                        data = res.data;
                    }
                    this.setState(prevState => {
                        if (clear || params.start === 1) {
                            prevState.draftData = [];
                        }
                        this.reloadAllDataCache(data);
                        prevState.draftData.push(...data);
                        prevState.loading = false;
                        return prevState;
                    });
                }
            });
            // getMaterialList(params, (res) => {
            //     this.setState(prevState => {
            //         if (clear || params.start === 1) {
            //             prevState.draftData = [];
            //         }
            //         this.reloadAllDataCache(res.data);
            //         prevState.draftData.push(...res.data);
            //         prevState.loading = false;
            //         return prevState;
            //     });
            //     window.loading.hide();
            // })

        } else if (currentTab === 'adopt') { // 已定稿？
            let params = {
                tabType: currentTab,
                start: (() => {
                    if (clear) {
                        this.params.allStart = this.defaultParams.allStart;
                    }
                    return this.params.allStart
                })(),
                size: this.default.size,
                mediaId: this.params.mediaId,
                queryStr: this.params.queryStr
            };
            getMaterialList(params, (res) => {
                this.setState(prevState => {
                    if (clear || params.start === 1) {
                        prevState.adoptData = [];
                    }
                    this.reloadAllDataCache(res.data);
                    prevState.adoptData.push(...res.data);
                    prevState.loading = false;
                    return prevState;
                });
                window.loading.hide();
            })
        } else if (currentTab === 'audit') { // 审核中
            let params = {
                tabType: currentTab,
                page: (() => {
                    if (clear) {
                        this.params.auditStart = this.defaultParams.auditStart;
                    }
                    return this.params.auditStart
                })(),
                size: this.default.size,
                mediaId: this.params.mediaId,
                keywords: this.params.queryStr
            };
            this.request({
                url: '/cm-sites-pms/material/auditList',
                body: params,
                callBack: (res) => {
                    let data = [];
                    if(res.data) {
                        data = res.data;
                    }
                    this.setState(prevState => {
                        if (clear || params.start === 1) {
                            prevState.auditData = [];
                        }
                        this.reloadAllDataCache(data);
                        prevState.auditData.push(...data);
                        prevState.loading = false;
                        return prevState;
                    });
                }
            });
            // getMaterialList(params, (res) => {
            //     this.setState(prevState => {
            //         if (clear || params.start === 1) {
            //             prevState.auditData = [];
            //         }
            //         this.reloadAllDataCache(res.data);
            //         prevState.auditData.push(...res.data);
            //         prevState.loading = false;
            //         return prevState;
            //     });
            //     window.loading.hide();
            // })

        }
        setTimeout(() => {
            this.setState({
                clear: false
            })
        })
    };

    allDataCache;

    reloadAllDataCache = (data) => {
        let addToCacheList = [];
        let fromCacheRemove = [];
        data.map(material => {
            let isAddToCache = true;
            this.allDataCache.map(cache => {
                if (material.id === cache.id) {
                    material.uuid = cache.uuid ? cache.uuid : uuid();
                    let oldStuffList = cache.stuffList;
                    let newCache = Object.assign(cache, material);//这个里面stuffList的stuff没有uuid
                    fromCacheRemove.push(cache);
                    addToCacheList.push(newCache);
                    //cache 这个里面stuffList的stuff有uuid
                    for (let i = 0; newCache.stuffList && i < newCache.stuffList.length; i++) {
                        let newStuff = newCache.stuffList[i];
                        let _uuid = uuid();
                        for (let j = 0; oldStuffList && j < oldStuffList.length; j++) {
                            let oldStuff = oldStuffList[j];
                            if (oldStuff.id === newStuff.id) {
                                _uuid = oldStuff.uuid ? oldStuff.uuid : _uuid;
                                break;
                            }
                        }
                        newStuff.uuid = _uuid;
                    }
                    isAddToCache = false;
                    material.stuffList = newCache.stuffList;
                }
            });
            if (isAddToCache) {
                addToCacheList.push(material);
            }
        });
        this.allDataCache = this.allDataCache.filter(cache => {
            let remove = false;
            fromCacheRemove.map(item => {
                if (cache.id === item.id) remove = true;
            });
            return !remove;
        });
        this.allDataCache.push(...addToCacheList);
    };

    reloadMaterialList = () => {
        let currentTab = this.state.key;
        if (currentTab === 'all') {
            this.params.allStart = 1;
        } else if (currentTab === 'needHandle') {
            this.params.needHandleStart = 1;
        } else if (currentTab === 'approved') {
            this.params.approvedStart = 1;
        } else if (currentTab === 'published') {
            this.params.publishedStart = 1;
        } else if (currentTab === 'abandoned') {
            this.params.abandonedStart = 1;
        } else if (currentTab === 'draft') {
            this.params.draftStart = 1;
        } else if (currentTab === 'audit') {
            this.params.auditStart = 1;
        }
        this.initData(currentTab, true);
    };

    onTabChange = (key, type) => {
        this.setState({[type]: key,  clear: true}, () => {
            this.params.queryStr = "";
            this.initData(key, true);
        });
    };

    /*监听滚动*/
    onScroll = e => {
        if (this.state.clear) {
            return
        }
        if (e.target.scrollTop + e.target.clientHeight === e.target.scrollHeight) {
            // 滚动到底部需要做的事情
            let currentTab = this.state.key;
            if (currentTab === 'all') {
                this.params.allStart++;
            } else if (currentTab === 'needHandle') {
                this.params.needHandleStart++;
            } else if (currentTab === 'approved') {
                this.params.approvedStart++;
            } else if (currentTab === 'published') {
                this.params.publishedStart++;
            } else if (currentTab === 'abandoned') {
                this.params.abandonedStart++;
            } else if (currentTab === 'draft') {
                this.params.draftStart++;
            } else if (currentTab === 'audit') {
                this.params.auditStart++;
            }
            this.initData(currentTab, false);
        }
    };

    search = value => {
        this.params.queryStr = value;
        let currentTab = this.state.key;
        if (currentTab === 'all') {
            this.params.allStart = 1;
            this.setState({
                allData: []
            });
        } else if (currentTab === 'needHandle') {
            this.params.needHandleStart = 1;
            this.setState({
                needHandleData: []
            });
        } else if (currentTab === 'approved') {
            this.params.approvedStart = 1;
            this.setState({
                approvedData: []
            });
        } else if (currentTab === 'published') {
            this.params.publishedStart = 1;
            this.setState({
                publishedData: []
            });
        } else if (currentTab === 'abandoned') {
            this.params.abandonedStart = 1;
            this.setState({
                abandonedData: []
            });
        } else if (currentTab === 'draft') {
            this.params.draftStart = 1;
            this.setState({
                draftData: []
            });
        } else if (currentTab === 'audit') {
            this.params.auditStart = 1;
            this.setState({
                auditData: []
            });
        }
        this.initData(currentTab, true);
    };

    editMaterial = (materialId, mediaId, call) => {
        if (call) {
            this.callback = call
        }
        if (mediaId) {
            this.params.mediaId = mediaId;
            this.defaultParams.mediaId = mediaId;
        }
        let title = parseInt(materialId) > 0 ? "编辑素材" : "新增素材";
        this.setState({
            editModalVisible: true,
            editModalTitle: title,
            editModalMaterialId: materialId || 0,
        })
    };

    /**
     * 隐藏素材编辑框
     * @param reload   是否需要刷新素材列表
     */
    updateEditModalVisible = (reload) => {
        this.setState({
            editModalVisible: false
        });
        if (reload) {
            this.reloadMaterialList();
        }
    };

    redirect = (type) => {
        message.destroy();
        // 以下这个接口被插件拦截，成功拦截后修改请求头，后台根据请求头信息返回是否安装插件，请知悉！
        this.request({
            url: "/cm-sites-pms/material/installedPlugin",
            callBack: (res) => {
                let isHttps = window.location.protocol.startsWith("https");
                if (!isHttps) {
                    message.destroy();
                    message.warn("检测到当前系统是http访问，插件功能无法正常使用");
                    return;
                }
                if (!res) {
                    message.destroy();
                    message.warn("获取插件信息失败！");
                    return;
                }
                if (!res.installed) {
                    message.destroy();
                    message.warn("检测到您未安装融媒体插件，请先安装后使用！");
                    return;
                }
                if (!res.rightVersion) {
                    message.destroy();
                    message.warn("检测到您安装的插件不是最新版本，请重新安装后使用！");
                    return;
                }
                if (type === 'weChat') {
                    this.getMediaById()
                } else {
                    window.open('https://xiumi.us?mediaId=' + this.defaultParams.mediaId+'&t='+Date.now())
                }
            }
        });
    };

    getMediaById = () => {
        this.request({
            url: "/cm-sites-pms/media/getById",
            body: {
                mediaId:this.defaultParams.mediaId
            },
            callBack: (res) => {
                if(res && res.mediaProperty && res.mediaProperty.account) {
                    this.weixinOpener = window.open('https://mp.weixin.qq.com?appId=' + res.mediaProperty.account+'&t='+Date.now())
                } else {
                    message.warn("当前公众号appId丢失！")
                }
            }
        })
    };

    infoAuth(params) {
            //校验公众号
            if (params.appId.trim().length === 0) {
                message.error('请输入AppId！');
                return false;
            }
            if (params.appSecret.trim().length === 0) {
                if (this.state.mediaTypeCode === "material") {
                    message.error('请输入AppSecret！');
                } else {
                    message.error('请输入AppToken！');
                }
                return false;
            }
        this.getAuthResult(params);  //认证
    }

    getAuthResult(params) {
            let body = {
                appId: params.appId,
                appSecret: params.appSecret,
                mediaId:this.defaultParams.mediaId,
                type: params.wechatType
            };
            verifyWechat(body, (data, status) => {
                if (status === 200) {
                    this.setState({
                        weChatVisible: false
                    });
                    this.getDisable();
                }
            }, {
                info: (info) => {
                    message.error(info);
                }
            })

    }

    //获取是否禁用
    getDisable = () => {
        this.request({
            url: "/cm-sites-pms/media/getById",
            body: {
                mediaId:this.defaultParams.mediaId
            },
            callBack: (res) => {
                let disable = true;
                if(res) {
                    disable = res.disable === 0 && res.authResult === 1?false:true
                }
                if (res && res.authResult === 0) {
                    this.state.weChatVisible = true;
                }
                this.setState({
                    disable:disable,
                    description:res.description,
                    authResult:res.authResult,
                    mediaName: res.name,
                });
            }
        })
    };
    renderTitle = () => {
        return (
            <div className="wexin">
                {/*<div className="left" style={{width: 90}}>微信发布</div>*/}
                <div className="">
                    <Tabs
                        activeKey={this.state.key}
                        onChange={key => {
                            this.onTabChange(key, 'key');
                        }}
                    >
                        {
                            tabList.map((item, i) => {
                                if (item.tab === '待我处理') {
                                    return (
                                        <TabPane
                                            tab={
                                                <div>
                                                    <div>待我处理</div>
                                                    {
                                                        this.state.topRedNum > 0 ? <div style={{
                                                            width: 31,
                                                            height: 16,
                                                            background: '#ff5b57',
                                                            color: 'white',
                                                            fontSize: 12,
                                                            position: 'absolute',
                                                            top: 5,
                                                            right: -13,
                                                            textAlign: 'center',
                                                            borderRadius: '8px',
                                                            lineHeight: '16px',
                                                            cursor: 'pointer',
                                                            margin: 'auto',
                                                            fontWeight: 'normal'
                                                        }}>{this.state.topRedNum < 100 ? this.state.topRedNum : '99+'}
                                                        </div> : null
                                                    }
                                                </div>
                                            }
                                            key={'needHandle'}
                                        >
                                        </TabPane>
                                    )
                                }
                                return (
                                    <TabPane tab={item.tab} key={item.key}></TabPane>
                                )
                            })
                        }

                    </Tabs>
                    <style>
            {/*            {`*/}
            {/*              */}
            {/*.wexin .ant-tabs-bar{*/}
            {/*    border: none*/}
            {/*}*/}
            {/*.wexin  .ant-tabs-bar .ant-tabs-tab-active {*/}
            {/*  color:${this.themeBgColor}!important ;*/}
            {/*  font-weight:bold !important;*/}
            {/* font-size:16px !important;*/}
            {/*    }*/}
            {/*    .wexin  .ant-tabs-nav-container  {*/}
            {/* font-size:16px !important;*/}
            {/*    }*/}
            {/*  .wexin .ant-tabs-ink-bar{*/}
            {/*    background-color:  ${this.themeBgColor} !important;*/}
            {/*    }*/}
            {/*   .wexin  .ant-tabs-nav .ant-tabs-tab {*/}
            {/*   color: #6c748b;*/}
            {/*   font-weight:bold !important;*/}
            {/*   }*/}
            {/* .wexin  .ant-tabs-nav .ant-tabs-tab:hover {*/}
            {/*    color: ${this.themeBgColor} !important;*/}
            {/*}*/}
            {/*                 `}*/}
                        {
                            `
                            .wexin .ant-tabs-nav-wrap {
                                padding: 0 32px
                            }
                            `
                        }
                    </style>
                </div>
               {/* <div style={{width: 336}}>
                    <Button type="primary" style={{
                        background: this.themeBgColor,
                        borderColor: this.themeBgColor,
                        marginRight: 20,
                        float: 'left'
                    }} onClick={() => this.redirect('weChat')}>打开公众号后台</Button>
                    <Button type="primary" style={{
                        background: this.themeBgColor,
                        borderColor: this.themeBgColor,
                        float: 'left'
                    }} onClick={() => this.redirect('xiumi')}>打开秀米后台</Button>
                </div>*/}
            </div>
        )
    };

    renderTop = () => {
        let {disable,authResult} = this.state;
        console.log(this.state.disable,'disable')
        return (
            <div className="we-xin-publish-top" style={{padding: '24px 32px'}}>
                <div style={{display: "flex"}}>
                    {disable?null:<Button type={'primary'} onClick={() => this.editMaterial(-1)}>添加</Button>}
                    <Button type="default" style={{ marginLeft: 24,}} onClick={() => this.redirect('weChat')}>打开公众号后台</Button>
                    <Button type="default" style={{marginLeft: 24}} onClick={() => this.redirect('xiumi')}>打开秀米后台</Button>
                    {authResult=== 0?<Button type="default" style={{marginLeft: 24}} onClick={() =>this.setState({weChatVisible:true})}>去认证</Button>:null}
                </div>
                <Search value={this.params.queryStr} onChange={(e)=>{
                    this.params.queryStr = e.target.value;
                    this.setState({})
                }} placeholder="请输入搜索内容" onSearch={value => this.search(value)} style={{width: '224px'}}/>
                <style>{`
                .we-xin-publish-top .ant-input-affix-wrapper .ant-input{
                    background:rgba(0, 80, 179, 0.04);
                }
                `}</style>
            </div>
        )
    };

    renderContent = () => {
        let border = 1;
        let cardMargin = 15;
        let cardPadding = 24;
        let h = parseInt(HEADER_HEIGHT) + cardMargin * 2 + 103 + cardPadding * 2 + border * 2;
        let height = "calc(100vh - " + h + "px)";
        let width = "100%";
        let currentTab = this.state.key;
        let currentData;
        if (currentTab === 'all') {
            currentData = this.state.allData;
        } else if (currentTab === 'needHandle') {
            currentData = this.state.needHandleData;
        } else if (currentTab === 'published') {
            currentData = this.state.publishedData;
        } else if (currentTab === 'abandoned') {
            currentData = this.state.abandonedData;
        } else if (currentTab === 'draft') {
            currentData = this.state.draftData;
        } else if (currentTab === 'adopt') {
            currentData = this.state.adoptData;
        } else if (currentTab === 'audit') {
            currentData = this.state.auditData;
        }
        currentData = currentData.filter((item) => item.stuffList.length !== 0);
        this.allDataCache = currentData;
        let content =
            (<Scrollbars
                onScroll={this.onScroll.bind(this)}
                autoHide
                autoHideTimeout={1}
                autoHideDuration={1}
                style={{height, width}}
            >
                {
                    <Masonry
                        breakpointCols={{
                            default: 4,
                        }}
                        >
                        {currentData && currentData.map((item, index)=>{
                            // item.uuid = item.id ? item.id : uuid();
                            return (
                                <div key={item.id || index} className="item">
                                    <StuffCard disable={this.state.disable} {...item} editMaterial={this.editMaterial.bind(this)}
                                               reloadMaterialList={this.reloadMaterialList.bind(this)}/>
                                </div>
                            )
                        })}
                    </Masonry>
                }
                <style>{`
                .we-xin-publish .my-masonry-grid{
                    display: flex;
                    padding: 0 -10px
                }
                .we-xin-publish .my-masonry-grid .item{
                    margin: 10px
                }
                `}</style>
            </Scrollbars>);
        return (
            <div className="we-xin-publish-content">
                {
                    currentData && currentData.length > 0 ?
                        <Card
                            headStyle={{fontSize: "12px", padding: "0 10px", border: 'none'}}
                            bordered={false}
                            bodyStyle={{padding: "0 32px"}}
                            style={{}}
                        >
                            {content}
                        </Card>
                        :
                        <div
                            style={{height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            <Empty/>
                        </div>
                }
            </div>
        )
    };
}

export class MaterialModel extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            title: props.title,
            materialId: props.materialId || 0,
            mediaId: props.mediaId,
            visible: props.visible,
            mediaName: props.mediaName,
            uuid: uuid()
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps !== this.props) {
            this.setState({
                title: nextProps.title,
                materialId: nextProps.materialId || 0,
                mediaId: nextProps.mediaId,
                visible: nextProps.visible,
                mediaName: nextProps.mediaName,
                uuid: uuid()
            });
            this.updateVisible = nextProps.updateVisible;
        }
    }

    updateVisible = () => {
    };

    onCancel = (reload) => {
        this.props.refeshList();
        if(this.props.callback){ // 外部页面回调
            this.props.callback()
        }
        if(this.urlParams) {
            this.removeParentParams();
        }
        if (this.updateVisible) {
            this.updateVisible(reload);
        } else {
            this.props.refeshList();
            this.setState({
                visible: false,
                uuid: uuid()
            })
        }
    };

    render() {
        let {title, visible, mediaId, materialId, mediaName, uuid} = this.state;
        if (!visible) {
            return null
        }
        return <Modal
            title={title}
            visible={visible}
            footer={null}
            // width={1200}
            width={"auto"}
            centered={true}
            maskClosable={false}
            onCancel={() => this.onCancel(false)}
            bodyStyle={{padding: 0, overflowX: "hidden"}}
            className={'addMaterial'}
        >
            <EditMaterial
                onAdvance={() => this.onCancel(true)}
                key={uuid}
                mediaId={mediaId}
                mediaName={mediaName}
                materialId={materialId}/>
            <style>{`
            .addMaterial .ant-modal-header{
                padding:13px 24px !important;
            }
            .addMaterial .ant-modal-close-x{
                line-height:48px !important;
            }
            `}</style>
        </Modal>
    }
}

function mapStateToProps(state)  {
    return {
        config: state.systemReducer.config,
    }
}

export default connect(mapStateToProps, null, null, {forwardRef  : true})(WeChatPublish);